import React from 'react'
import { motion } from 'framer-motion'


// Header will fade in on page load
const quote = {
    initial:{
        opacity:1
    },
    animate:{
        opacity:1,
        transition:{
            delay:0.5,
            staggerChildren:0.08
        }
    }
}

const singleWord = {
    initial:{
        opacity:0,
        y:50
    },
    animate:{
        opacity:1,
        y:0,
        transition:{
            duration:0.75
        }
    }
}


const AnimatedText = ({text, className=''}) => {
  return (
    <div className='w-full mx-auto py-2 flex items-center justify-center text-center overflow-hidden '>

        <motion.h1 className={`inline-clock w-full font-bold capitalize text-8xl text-dark dark:text-light ${className}`}
                   variants={quote} initial="initial" animate="animate">
        
            {text.split(' ').map((word,i) => 
                <motion.span key={word+'-'+i} className='inline-block'
                             variants={singleWord}>
                    {word}&nbsp;
                </motion.span>
            )}

        </motion.h1>
    
    </div>
  )
}

export default AnimatedText